import { Leaf, ShieldCheck, HeartHandshake, Sparkles, Hand } from "lucide-react";

export const FeaturesSection = () => {
  return (
    <section 
      id="features" 
      className="py-20 md:py-32 px-6 md:px-12 bg-white relative overflow-hidden"
      data-testid="features-section"
    >
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-sage/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-citrus/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <span className="inline-block text-sm font-medium text-forest bg-sage px-4 py-2 rounded-full">
            Why Choose Plantora
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-forest">
            The Power of Plants
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg">
            Our innovative formulas harness nature's cleaning power without harsh chemicals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          <div 
            className="bento-item lg:col-span-2 lg:row-span-2 p-8 md:p-10 rounded-3xl bg-sage relative overflow-hidden group"
            data-testid="feature-plant-based"
          >
            <div className="relative z-10">
              <div className="w-16 h-16 rounded-2xl bg-forest/10 flex items-center justify-center mb-6">
                <Leaf className="w-8 h-8 text-forest" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl font-semibold text-forest mb-4">
                Plant-Based Power
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed max-w-md">
                Made with natural plant-derived ingredients that are effective yet gentle on the environment.
              </p>
            </div>
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-forest/5 rounded-full group-hover:scale-110 transition-transform duration-500" />
          </div>

          <div 
            className="bento-item p-6 md:p-8 rounded-3xl bg-stone-50 border border-stone-100"
            data-testid="feature-soft-hands"
          >
            <div className="w-12 h-12 rounded-xl bg-forest/10 flex items-center justify-center mb-4">
              <Hand className="w-6 h-6 text-forest" />
            </div>
            <h3 className="font-serif text-xl font-semibold text-forest mb-2">
              Soft on Hands
            </h3>
            <p className="text-gray-600 text-sm">
              Gentle formula that protects your hands while delivering powerful cleaning.
            </p>
          </div>

          <div 
            className="bento-item p-6 md:p-8 rounded-3xl bg-citrus/10 border border-citrus/20"
            data-testid="feature-safe"
          >
            <div className="w-12 h-12 rounded-xl bg-citrus/30 flex items-center justify-center mb-4">
              <HeartHandshake className="w-6 h-6 text-forest" />
            </div>
            <h3 className="font-serif text-xl font-semibold text-forest mb-2">
              Safe for Family
            </h3>
            <p className="text-gray-600 text-sm">
              Non-toxic formula safe for kids and pets.
            </p>
          </div>

          <div 
            className="bento-item lg:col-span-2 p-6 md:p-8 rounded-3xl bg-stone-50 border border-stone-100 flex flex-col md:flex-row md:items-center gap-6"
            data-testid="feature-sparkling"
          >
            <div className="w-12 h-12 rounded-xl bg-forest/10 flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-6 h-6 text-forest" />
            </div>
            <div>
              <h3 className="font-serif text-xl font-semibold text-forest mb-2">
                Sparkling Shine
              </h3>
              <p className="text-gray-600 text-sm">
                Leaves surfaces brilliantly clean with a streak-free sparkling shine.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
